export function getIconColor(icon_color: string) {
  let color = icon_color.replace('#', '');
  let a = color.substr(0, 2);
  color = color.substring(2, 8) + a;
  return '#' + color;
}
